import { CircleAlert, CircleCheckBig } from "lucide-react";

type MessageStatus = "success" | "error";

export function ToastMessage({
  message,
  status = "success",
}: {
  message: string;
  status?: MessageStatus;
}) {
  let messageIcon = <CircleCheckBig />;

  if (status === "error") messageIcon = <CircleAlert />;

  return (
    <div className="flex justify-start items-center text-red">
      {messageIcon}
      <span className="pl-4">{message}</span>
    </div>
  );
}
